import { GetterTree, MutationTree, ActionTree } from "vuex";

class State{
    alert = {
        show:false,
        message:'',
        type:'neutral'
    }
}

const getters = <GetterTree<State, any>>{
    isAlertShown(state): boolean {
        return state.alert.show
    },
    getAlertMessage(state):string {
        return state.alert.message
    },
    getAlertType(state):string{
        return state.alert.type
    }
}

const mutations = <MutationTree<State>>{
    setIsAlertShown(state,payload){
        let saveTimeout: ReturnType<typeof setTimeout> = setTimeout(() => {}, 5000)

        if(saveTimeout) clearTimeout(saveTimeout)

        if(!payload.show) state.alert.show = false

        if(state.alert.show) return

        console.log('Mutation alert',payload)

        state.alert.show = payload.show
        state.alert.message = payload.message
        state.alert.type = payload.type

        saveTimeout = setTimeout(() => {

            state.alert.show = false
            state.alert.message = ''
            state.alert.type = 'neutral'

            clearTimeout(saveTimeout)

          }, 5000)
    }
}

const actions = <ActionTree<State, any>>{
    setAlertShown({ commit }, {show,message,type}){
        commit('setIsAlertShown',{show,message,type})
        
    }
}

const EventModule = {
    state: new State(),
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default EventModule